import { createRoute } from '@/utils/routing'

export const PRIVATE_PROFILE_LIST_ROUTE = 'profiles-private'
export const LEGAL_PROFILE_LIST_ROUTE = 'profiles-legal'
export const REMITTANCE_PROFILE_LIST_ROUTE = 'profiles-remittance'
export const PROFILE_ACCOUNT_LIST_ROUTE = 'profiles-profileId-accounts'
export const PROFILE_SAVINGS_LIST_ROUTE = 'profiles-profileId-savings'
export const PROFILE_CUSTOMER_LIST_ROUTE = 'profiles-profileId-customers'
export const PROFILE_FOREX_SETUP_LIST_ROUTE = 'profiles-profileId-forex-setup'
export const PROFILE_CARD_LIST_ROUTE = 'profiles-profileId-cards'
export const PROFILE_CARD_ORDER_LIST_ROUTE = 'profiles-profileId-card-orders'
export const PROFILE_CLIENT_REQUEST_LIST_ROUTE = 'profiles-profileId-requests'
export const PROFILE_USER_LIST_ROUTE = 'profiles-profileId-users'
export const PROFILE_PAYMENT_LIST_ROUTE = 'profiles-profileId-payments'
export const PROFILE_OPEN_BANKING_PAYMENTS_ROUTE = 'profiles-profileId-open-banking'
export const PROFILE_FEE_LIST_ROUTE = 'profiles-profileId-fees'
export const PROFILE_ACTIVITY_LIST_ROUTE = 'profiles-profileId-activity'
export const PROFILE_SETTINGS_ROUTE = 'profiles-profileId-settings'
export const PROFILE_FEATURE_LIST_ROUTE = 'profiles-profileId-features'
export const PROFILE_CASHBACK_RULE_LIST_ROUTE = 'profiles-profileId-cashback'
export const PROFILE_WATCHDOG_RULE_LIST_ROUTE = 'profiles-profileId-watchdog'
export const PROFILE_CARD_TOPUP_LIMITS_ROUTE = 'profiles-profileId-card-topup'
export const PROFILE_PAYMENT_ORDER_LIST_ROUTE = 'profiles-profileId-payment-orders'
export const PROFILE_ESIM_REISSUE_ROUTE = 'profiles-profileId-esim-reissue'
export const PROFILE_RESTRICTIONS_ROUTE = 'profiles-profileId-restrictions'

function createRouteWithProfileId (name, profileId, options) {
  if (profileId != null) {
    return createRoute(name, {
      params: { ...options.params, profileId },
      query: options.query
    })
  }
}

export function createPrivateProfileListRoute (options = {}) {
  return createRoute(PRIVATE_PROFILE_LIST_ROUTE, options)
}

export function createLegalProfileListRoute (options = {}) {
  return createRoute(LEGAL_PROFILE_LIST_ROUTE, options)
}

export function createRemittanceProfileListRoute (options = {}) {
  return createRoute(REMITTANCE_PROFILE_LIST_ROUTE, options)
}

export function createProfileAccountListRoute (profileId, options = {}) {
  return createRouteWithProfileId(PROFILE_ACCOUNT_LIST_ROUTE, profileId, options)
}

export function createProfileSavingsListRoute (profileId, options = {}) {
  return createRouteWithProfileId(PROFILE_SAVINGS_LIST_ROUTE, profileId, options)
}

export function createProfileCustomerListRoute (profileId, options = {}) {
  return createRouteWithProfileId(PROFILE_CUSTOMER_LIST_ROUTE, profileId, options)
}

export function createProfileForexSetupListRoute (profileId, options = {}) {
  return createRouteWithProfileId(PROFILE_FOREX_SETUP_LIST_ROUTE, profileId, options)
}

export function createProfileCardListRoute (profileId, options = {}) {
  return createRouteWithProfileId(PROFILE_CARD_LIST_ROUTE, profileId, options)
}

export function createProfileCardOrderListRoute (profileId, options = {}) {
  return createRouteWithProfileId(PROFILE_CARD_ORDER_LIST_ROUTE, profileId, options)
}

export function createProfileClientRequestListRoute (profileId, options = {}) {
  return createRouteWithProfileId(PROFILE_CLIENT_REQUEST_LIST_ROUTE, profileId, options)
}

export function createProfileUserListRoute (profileId, options = {}) {
  return createRouteWithProfileId(PROFILE_USER_LIST_ROUTE, profileId, options)
}

export function createProfilePaymentListRoute (profileId, options = {}) {
  return createRouteWithProfileId(PROFILE_PAYMENT_LIST_ROUTE, profileId, options)
}

export function createProfileOpenBankingPaymentsRoute (profileId, options = {}) {
  return createRouteWithProfileId(PROFILE_OPEN_BANKING_PAYMENTS_ROUTE, profileId, options)
}

export function createProfileFeeListRoute (profileId, options = {}) {
  return createRouteWithProfileId(PROFILE_FEE_LIST_ROUTE, profileId, options)
}

export function createProfileActivityListRoute (profileId, options = {}) {
  return createRouteWithProfileId(PROFILE_ACTIVITY_LIST_ROUTE, profileId, options)
}

export function createProfileSettingsRoute (profileId, options = {}) {
  return createRouteWithProfileId(PROFILE_SETTINGS_ROUTE, profileId, options)
}

export function createProfileFeatureListRoute (profileId, options = {}) {
  return createRouteWithProfileId(PROFILE_FEATURE_LIST_ROUTE, profileId, options)
}

export function createProfileCashbackRuleListRoute (profileId, options = {}) {
  return createRouteWithProfileId(PROFILE_CASHBACK_RULE_LIST_ROUTE, profileId, options)
}

export function createProfileWatchdogRuleListRoute (profileId, options = {}) {
  return createRouteWithProfileId(PROFILE_WATCHDOG_RULE_LIST_ROUTE, profileId, options)
}

export function createProfileCardTopupLimitsRoute (profileId, options = {}) {
  return createRouteWithProfileId(PROFILE_CARD_TOPUP_LIMITS_ROUTE, profileId, options)
}

export function createProfilePaymentOrderListRoute (profileId, options = {}) {
  return createRouteWithProfileId(PROFILE_PAYMENT_ORDER_LIST_ROUTE, profileId, options)
}

export function createProfileEsimReissueRoute (profileId, options = {}) {
  return createRouteWithProfileId(PROFILE_ESIM_REISSUE_ROUTE, profileId, options)
}

export function createProfileRestrictionsRoute (profileId, options = {}) {
  return createRouteWithProfileId(PROFILE_RESTRICTIONS_ROUTE, profileId, options)
}
